import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { getAnnouncementDetail } from '@/api';
import type { AnnouncementItem } from '@/api';

export default function AnnouncementDetail() {
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();
  const [item, setItem] = useState<(AnnouncementItem & { detailContent: string }) | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;
    getAnnouncementDetail(Number(id))
      .then((res) => {
        if (mounted) setItem(res);
      })
      .catch(() => {
        //加载失败保持 null，下方展示"公告不存在"
      })
      .finally(() => {
        if (mounted) setLoading(false);
      });
    return () => {
      mounted = false;
    };
  }, [id]);

  if (loading) {
    return (
      <div className="mobile-container bg-white min-h-screen flex items-center justify-center">
        <i className="ri-loader-4-line text-primary-400 text-3xl animate-spin" />
      </div>
    );
  }

  if (!item) {
    return (
      <div className="mobile-container bg-white min-h-screen flex items-center justify-center">
        <div className="text-center">
          <i className="ri-file-close-line text-foreground-300 text-4xl mb-3 block" />
          <p className="text-foreground-400 text-sm">公告不存在</p>
          <button
            onClick={() => navigate(-1)}
            className="mt-4 text-primary-500 text-sm font-bold cursor-pointer"
          >
            返回
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="mobile-container bg-white min-h-screen">
      {/* Header */}
      <header className="flex items-center px-4 h-12 border-b border-background-200/50">
        <button
          onClick={() => navigate(-1)}
          className="w-8 h-8 flex items-center justify-center text-foreground-800 cursor-pointer active:scale-95 transition-transform"
          aria-label="返回"
        >
          <i className="ri-arrow-left-line text-xl" />
        </button>
        <h1 className="flex-1 text-center text-foreground-950 text-base font-bold">
          公告详情
        </h1>
        <div className="w-8" />
      </header>

      {/* Content */}
      <main className="px-4 py-5">
        <div className="flex items-center gap-2 mb-3">
          <span className="px-2 py-0.5 text-[10px] bg-white border border-background-300 text-foreground-400 rounded">
            通知
          </span>
          <span className="text-foreground-900 font-bold text-base">
            {item.title}
          </span>
        </div>
        <p className="text-foreground-400 text-xs mb-4">
          发布时间：{item.fullDate}
        </p>
        <div className="border-t border-background-200/60 pt-4">
          {item.detailContent || item.content ? (
            <div
              className="rich-content text-foreground-700 text-sm leading-relaxed [&_p]:my-2 [&_img]:max-w-full [&_img]:h-auto [&_img]:rounded-lg"
              dangerouslySetInnerHTML={{ __html: item.detailContent || item.content }}
            />
          ) : (
            <p className="text-foreground-400 text-sm">暂无内容</p>
          )}
        </div>
      </main>
    </div>
  );
}